import { render, staticRenderFns } from "./CreditorList.vue?vue&type=template&id=21f9dbb7"
import script from "./CreditorList.vue?vue&type=script&lang=js"
export * from "./CreditorList.vue?vue&type=script&lang=js"
import style0 from "./CreditorList.vue?vue&type=style&index=0&id=21f9dbb7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports